module.exports = __webpack_public_path__ + "img/icon-area-dashboard-active.0b2f89ac.svg";